<template>
  <div class="review-landing-preview">
    <!-- Review Sites Preview -->
    <div v-if="activeTab === 'review-sites'" class="preview-container">
      <!-- Header with gradient -->
      <div class="preview-header-gradient">
        <h2 class="business-name-header">{{ business.business.business_name }}</h2>
        <div class="rating-section-header">
          <span class="rating-value">{{ business.average || '4.9' }}</span>
          <div class="stars-container">
            <div class="stars-filled" :style="'width:' + starWidth + '%'">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon empty"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
            </div>
            <div class="stars-empty">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
            </div>
          </div>
          <span class="review-count-text">{{ business.total || 63 }} Reviews</span>
        </div>
      </div>

      <!-- Content -->
      <div class="preview-content-white">
        <!-- eslint-disable vue/no-v-html -->
        <h3 class="preview-title-center">
          <span v-html="parsedSitesContent.title"></span>
        </h3>
        <p class="preview-subtitle-center">
          <span v-html="parsedSitesContent.subtitle"></span>
        </p>
        <p class="preview-description-center">
          <span v-html="parsedSitesContent.description"></span>
        </p>
        <!-- eslint-enable vue/no-v-html -->

        <!-- Review Sites Grid -->
        <div class="review-sites-grid-exact">
          <div
            v-for="(site, i) in enabledSites"
            :key="i"
            class="review-site-card-exact"
          >
            <div class="site-logo-wrapper-exact">
              <div class="site-logo-inner">
                <img
                  v-if="imgSrc(site) !== null && site.type !== 'google'"
                  :src="imgSrc(site)"
                  :alt="site.label || site.type"
                  class="review-site-logo-exact"
                />
                <svg
                  v-else-if="site.type === 'google'"
                  viewBox="0 0 24 24"
                  class="review-site-logo-exact google-logo"
                  fill="#4285F4"
                >
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"></path>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"></path>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"></path>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"></path>
                </svg>
              </div>
            </div>
            <h5 class="site-label-exact">{{ site.label }}</h5>
            <button class="leave-review-btn">Leave Review</button>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="preview-footer-exact">
        <span>{{ business.business.address }}, {{ business.business.city }}, {{ business.business.state }} {{ business.business.zip }} | {{ business.business.business_phone }}</span>
      </div>
    </div>

    <!-- Feedback Gate Preview -->
    <div v-else-if="activeTab === 'feedback-gate'" class="preview-container">
      <!-- Feedback Tab -->
      <div v-if="previewTab === 'feedback'" class="gate-preview-wrapper">
        <!-- Gray Background Container -->
        <div class="gate-preview-gray-bg">
          <!-- Blue Gradient Header -->
          <div class="gate-preview-header-gradient">
            <h2 class="gate-preview-business-name">{{ business.business.business_name }}</h2>
            <div class="gate-preview-rating">
              <span class="gate-preview-rating-value">{{ business.average || '4.9' }}</span>
              <div class="gate-preview-stars">
                <div class="gate-preview-stars-filled" :style="'width:' + starWidth + '%'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon empty"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                </div>
                <div class="gate-preview-stars-empty">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                </div>
              </div>
              <span class="gate-preview-review-count">({{ business.total || 63 }} reviews)</span>
            </div>
          </div>

          <!-- White Content Section -->
          <div class="gate-preview-white-content">
            <div class="gate-preview-content-inner">
              <!-- eslint-disable vue/no-v-html -->
              <h3 class="gate-preview-title-text">
                <span v-html="business.business.review_gate_settings.body_title || 'How was your recent experience?'"></span>
              </h3>
              <p class="gate-preview-body-text">
                <span v-html="business.business.review_gate_settings.body_text || 'Thanks for choosing us! Would you please take a moment to rate your experience? Your feedback is highly appreciated, and your response will help us serve you even better in the future.'"></span>
              </p>
              <!-- eslint-enable vue/no-v-html -->

              <!-- Feedback Buttons -->
              <div class="gate-preview-buttons-grid">
                <button class="gate-preview-button gate-preview-button-good">
                  <div class="gate-button-icon-wrapper gate-button-icon-good">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="gate-thumbs-icon">
                      <path d="M7 10v12"></path>
                      <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"></path>
                    </svg>
                  </div>
                  <div class="gate-button-label">
                    <span>{{ business.business.review_gate_settings.good_label || 'I had a good experience' }}</span>
                  </div>
                </button>
                <button class="gate-preview-button gate-preview-button-bad">
                  <div class="gate-button-icon-wrapper gate-button-icon-bad">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="gate-thumbs-icon">
                      <path d="M17 14V2"></path>
                      <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"></path>
                    </svg>
                  </div>
                  <div class="gate-button-label">
                    <span>{{ business.business.review_gate_settings.bad_label || 'I had a bad experience' }}</span>
                  </div>
                </button>
              </div>
            </div>
            <!-- Gray Footer -->
            <div class="gate-preview-footer-gray">
              <span>{{ business.business.address }}, {{ business.business.city }}, {{ business.business.state }} {{ business.business.zip }} | {{ business.business.business_phone }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Positive Tab -->
      <div v-else-if="previewTab === 'positive'" class="gate-preview-wrapper">
        <!-- Gray Background Container -->
        <div class="gate-preview-gray-bg">
          <!-- Blue Gradient Header -->
          <div class="gate-preview-header-gradient">
            <h2 class="gate-preview-business-name">{{ business.business.business_name }}</h2>
            <div class="gate-preview-rating">
              <span class="gate-preview-rating-value">{{ business.average || '4.9' }}</span>
              <div class="gate-preview-stars">
                <div class="gate-preview-stars-filled" :style="'width:' + starWidth + '%'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon empty"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                </div>
                <div class="gate-preview-stars-empty">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                </div>
              </div>
              <span class="gate-preview-review-count">{{ business.total || 63 }} Reviews</span>
            </div>
          </div>

          <!-- White Content Section -->
          <div class="gate-preview-white-content-positive">
            <h3 class="gate-preview-positive-title">
              <span>{{ sitesContent.pageTitle || 'Leave Us A Review!' }}</span>
            </h3>
            <p class="gate-preview-positive-subtitle">
              <span>{{ sitesContent.subtitle || 'Thanks for stopping by!' }}</span>
            </p>
            <!-- eslint-disable vue/no-v-html -->
            <p class="gate-preview-positive-description">
              <span v-html="sitesContent.description || 'We\'d love it if you could leave us a review on one of the sites below! Please mention your server Sarah in the review so we can recognize them for their service.'"></span>
            </p>
            <!-- eslint-enable vue/no-v-html -->
            
            <div class="gate-preview-sites-grid">
              <div
                v-for="(site, i) in enabledSites"
                :key="i"
                class="gate-preview-site-card"
              >
                <div class="gate-site-logo-wrapper">
                  <div class="gate-site-logo-inner">
                    <img
                      v-if="imgSrc(site) !== null"
                      :src="imgSrc(site)"
                      :alt="site.label || site.type"
                      class="gate-site-logo-img"
                    />
                    <div v-else class="gate-site-logo-placeholder">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-globe-icon">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                        <path d="M2 12h20"></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <h5 class="gate-site-label">{{ site.label || 'New Site' }}</h5>
                <button class="gate-leave-review-btn">Leave Review</button>
              </div>
            </div>
          </div>
          
          <!-- Gray Footer -->
          <div class="gate-preview-footer-gray">
            <span>{{ business.business.address }}, {{ business.business.city }}, {{ business.business.state }} {{ business.business.zip }} | {{ business.business.business_phone }}</span>
          </div>
        </div>
      </div>

      <!-- Negative Tab -->
      <div v-else-if="previewTab === 'negative'" class="gate-preview-wrapper">
        <!-- Gray Background Container -->
        <div class="gate-preview-gray-bg">
          <!-- Blue Gradient Header -->
          <div class="gate-preview-header-gradient">
            <h2 class="gate-preview-business-name">{{ business.business.business_name }}</h2>
            <div class="gate-preview-rating">
              <span class="gate-preview-rating-value">{{ business.average || '4.9' }}</span>
              <div class="gate-preview-stars">
                <div class="gate-preview-stars-filled" :style="'width:' + starWidth + '%'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon filled"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon empty"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                </div>
                <div class="gate-preview-stars-empty">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gate-star-icon"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                </div>
              </div>
              <span class="gate-preview-review-count">{{ business.total || 63 }} Reviews</span>
            </div>
          </div>

          <!-- White Content Section -->
          <div class="gate-preview-white-content-negative">
            <div class="gate-negative-header">
              <h3 class="gate-negative-title">
                <span>Please leave your feedback below</span>
              </h3>
            </div>
            <div class="gate-negative-form">
              <div class="gate-form-field">
                <label class="gate-form-label">Name <span class="gate-required">*</span></label>
                <input type="text" placeholder="Your name" class="gate-form-input" disabled />
              </div>
              <div class="gate-form-field">
                <label class="gate-form-label">Email <span class="gate-required">*</span></label>
                <input type="email" placeholder="your.email@example.com" class="gate-form-input" disabled />
              </div>
              <div class="gate-form-field">
                <label class="gate-form-label">Feedback <span class="gate-required">*</span></label>
                <textarea placeholder="Please tell us about your experience and how we can improve..." rows="6" class="gate-form-textarea" disabled></textarea>
              </div>
              <button class="gate-submit-btn">Submit</button>
            </div>
            <div class="gate-negative-footer">
              <p class="gate-negative-footer-text">
                If you prefer to just leave a review, <span class="gate-link-text">click here</span>
              </p>
            </div>
          </div>
          
          <!-- Gray Footer -->
          <div class="gate-preview-footer-gray">
            <span>{{ business.business.address }}, {{ business.business.city }}, {{ business.business.state }} {{ business.business.zip }} | {{ business.business.business_phone }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import '../../../design/custom/components/_dashboard.scss'
export default {
  name: 'ReviewLandingPagePreview',
  props: {
    business: {
      type: Object,
      required: true,
    },
    activeTab: {
      type: String,
      default: 'review-sites',
    },
    previewTab: {
      type: String,
      default: 'feedback',
    },
    sitesContent: {
      type: Object,
      default: () => ({
        pageTitle: '',
        subtitle: '',
        description: '',
      }),
    },
  },
  computed: {
    starWidth() {
      const avg = this.business?.average
      return avg ? (avg / 5) * 100 : 0
    },
    enabledSites() {
      const sites = this.business?.business?.review_sites
      if (!sites || !sites.length) return []

      const settings = this.business?.business?.review_gate_settings
      const sitesEnabled =
        !settings || settings.sites_enabled !== false

      if (!sitesEnabled) {
        return []
      }

      // Only show sites that are individually enabled
      return sites.filter((site) => site.enabled !== false)
    },
    parsedSitesContent() {
      // Optimize: Use direct access instead of complex parsing
      const content = this.sitesContent || {}
      return {
        title: content.pageTitle || 'Leave Us A Review!',
        subtitle: content.subtitle || 'Thanks for stopping by!',
        description: content.description || "We'd love it if you could leave us a review on one of the sites below!",
      }
    },
  },
  methods: {
    imgSrc(site) {
      let src = null
      if (
        site.type === 'google' &&
        (!site.hasOwnProperty('logo_path') ||
          site.logo_path === '' ||
          site.logo_path === 'null')
      ) {
        src = 'https://rengine.sfo3.cdn.digitaloceanspaces.com/google-icon-100.png'
      } else if (
        site.type === 'facebook' &&
        (!site.hasOwnProperty('logo_path') ||
          site.logo_path === '' ||
          site.logo_path === 'null')
      ) {
        src = 'https://rengine.sfo3.cdn.digitaloceanspaces.com/facebook-100.png'
      } else if (
        site.type === 'yelp' &&
        (!site.hasOwnProperty('logo_path') ||
          site.logo_path === '' ||
          site.logo_path === 'null')
      ) {
        src = 'https://rengine.sfo3.cdn.digitaloceanspaces.com/yelp-logo-100.png'
      } else if (site.logo_path && site.logo_path !== '' && site.logo_path !== 'null') {
        src = this.business.business.cdn_url + site.logo_path
      }
      return src
    },
  },
}
</script>

<style lang="scss" scoped>
.review-landing-preview {
  background: #f3f4f6;
  border-radius: 8px;
  padding: 24px;
  min-height: 500px;
}

.preview-container {
  min-height: 500px;
}

.preview-header-gradient {
  background: linear-gradient(to right, #2563eb, #1d4ed8);
  color: white;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 24px;

  .business-name-header {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 8px 0;
    color: white;
  }

  .rating-section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    .rating-value {
      font-size: 20px;
      font-weight: 600;
      color: white;
    }

    .stars-container {
      display: flex;
      position: relative;
      gap: 4px;

      .stars-filled {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        gap: 4px;
        overflow: hidden;
        z-index: 1;

        .star-icon {
          width: 16px;
          height: 16px;
          color: #fbbf24;
          fill: #fbbf24;
        }
      }

      .stars-empty {
        display: flex;
        gap: 4px;
        position: relative;
        z-index: 0;

        .star-icon {
          width: 16px;
          height: 16px;
          color: rgba(255, 255, 255, 0.5);
        }
      }
    }

    .review-count-text {
      font-size: 14px;
      color: white;
    }
  }
}

.preview-content-white {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  .preview-title-center {
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    text-align: center;
    margin: 0 0 16px 0;
  }

  .preview-subtitle-center {
    font-size: 16px;
    color: #4b5563;
    text-align: center;
    margin: 0 0 8px 0;
  }

  .preview-description-center {
    font-size: 16px;
    color: #4b5563;
    text-align: center;
    margin: 0 0 24px 0;
  }
}

.review-sites-grid-exact {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  max-width: 448px;
  margin: 0 auto;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.review-site-card-exact {
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #93c5fd;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .site-logo-wrapper-exact {
    width: 64px;
    height: 64px;
    margin: 0 auto 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    .site-logo-inner {
      width: 64px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;

      .review-site-logo-exact {
        width: 100%;
        height: 100%;
        object-fit: contain;
        
        &.google-logo {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .site-label-exact {
    font-weight: 600;
    font-size: 16px;
    color: #111827;
    margin: 0 0 8px 0;
  }

  .leave-review-btn {
    background: #2563eb;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    margin-top: 8px;

    &:hover {
      background: #1d4ed8;
    }
  }
}

.preview-footer-exact {
  text-align: center;
  font-size: 14px;
  color: #6b7280;
  margin-top: 24px;
  padding: 16px;
  background: #e5e7eb;
  border-radius: 4px;
}

.feedback-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.feedback-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px 32px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  min-width: 160px;
  transition: all 0.2s ease;

  .thumbs-icon {
    width: 48px;
    height: 48px;
  }

  span {
    font-weight: 600;
    font-size: 15px;
    color: #374151;
  }
}

.feedback-button-good {
  border-color: #10b981;

  .thumbs-icon {
    color: #059669;
  }
}

.feedback-button-bad {
  border-color: #ef4444;

  .thumbs-icon {
    color: #dc2626;
  }
}

.preview-footer {
  background: #f9fafb;
  padding: 16px;
  text-align: center;
  color: #9ca3af;
  font-size: 13px;
  border-top: 1px solid #e5e7eb;
}

.gate-preview-wrapper {
  width: 100%;
}

.gate-preview-gray-bg {
  background: #f3f4f6;
  border-radius: 8px;
  padding: 24px;
  min-height: 500px;
}

.gate-preview-header-gradient {
  background: linear-gradient(to right, #2563eb, #1d4ed8);
  color: white;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  
  .gate-preview-business-name {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 8px;
    color: white;
  }
  
  .gate-preview-rating {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .gate-preview-rating-value {
      font-size: 20px;
      font-weight: 600;
    }
    
    .gate-preview-stars {
      position: relative;
      display: flex;
      gap: 2px;
      
      .gate-preview-stars-filled {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        gap: 2px;
        overflow: hidden;
        z-index: 1;
      }
      
      .gate-preview-stars-empty {
        display: flex;
        gap: 2px;
        position: relative;
        z-index: 0;
      }
      
      .gate-star-icon {
        width: 16px;
        height: 16px;
        color: rgba(255, 255, 255, 0.5);
        
        &.filled {
          color: #fbbf24;
          fill: #fbbf24;
        }
      }
    }
    
    .gate-preview-review-count {
      font-size: 14px;
      margin-left: 4px;
    }
  }
}

.gate-preview-white-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  min-height: 400px;
  
  .gate-preview-content-inner {
    flex: 1;
    padding: 32px;
    text-align: center;
    
    .gate-preview-title-text {
      font-size: 20px;
      font-weight: 600;
      color: #111827;
      margin-bottom: 16px;
      
      span {
        display: block;
      }
    }
    
    .gate-preview-body-text {
      color: #4b5563;
      text-align: center;
      line-height: 1.6;
      margin-bottom: 32px;
      max-width: 512px;
      margin-left: auto;
      margin-right: auto;
      
      span {
        display: block;
      }
    }
  }
  
  .gate-preview-buttons-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    max-width: 512px;
    margin: 0 auto;
    
    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    .gate-preview-button {
      border: 2px solid;
      border-radius: 8px;
      padding: 32px;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s;
      background: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      
      &:hover {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      }
      
      .gate-button-icon-wrapper {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.2s;
        
        &.gate-button-icon-good {
          background: #dcfce7;
          
          .gate-thumbs-icon {
            width: 32px;
            height: 32px;
            color: #16a34a;
          }
        }
        
        &.gate-button-icon-bad {
          background: #fee2e2;
          
          .gate-thumbs-icon {
            width: 32px;
            height: 32px;
            color: #dc2626;
          }
        }
      }
      
      .gate-button-label {
        font-weight: 500;
        font-size: 18px;
        color: #111827;
      }
      
      &.gate-preview-button-good {
        border-color: #86efac;
        
        &:hover {
          border-color: #4ade80;
          
          .gate-button-icon-good {
            background: #bbf7d0;
          }
        }
      }
      
      &.gate-preview-button-bad {
        border-color: #fca5a5;
        
        &:hover {
          border-color: #f87171;
          
          .gate-button-icon-bad {
            background: #fecaca;
          }
        }
      }
    }
  }
  
  .gate-preview-footer-gray {
    background: #e5e7eb;
    padding: 16px;
    text-align: center;
    font-size: 14px;
    color: #6b7280;
    border-radius: 8px;
    margin-top: 24px;
  }
}

.gate-preview-white-content-positive {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  
  .gate-preview-positive-title {
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 16px;
    text-align: center;
  }
  
  .gate-preview-positive-subtitle {
    color: #4b5563;
    margin-bottom: 8px;
    text-align: center;
  }
  
  .gate-preview-positive-description {
    color: #4b5563;
    margin-bottom: 24px;
    text-align: center;
  }
  
  .gate-preview-sites-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    max-width: 448px;
    margin: 0 auto;
    
    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    .gate-preview-site-card {
      border: 2px solid #e5e7eb;
      border-radius: 8px;
      padding: 24px;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s;
      background: white;
      
      &:hover {
        border-color: #93c5fd;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      }
      
      .gate-site-logo-wrapper {
        width: 64px;
        height: 64px;
        margin: 0 auto 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        .gate-site-logo-inner {
          width: 64px;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          
          .gate-site-logo-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          
          .gate-site-logo-placeholder {
            width: 64px;
            height: 64px;
            background: #f3f4f6;
            border-radius: 4px;
            border: 1px solid #e5e7eb;
            display: flex;
            align-items: center;
            justify-content: center;
            
            .gate-globe-icon {
              width: 32px;
              height: 32px;
              color: #6b7280;
            }
          }
        }
      }
      
      .gate-site-label {
        font-weight: 600;
        font-size: 16px;
        color: #111827;
        margin-bottom: 8px;
      }
      
      .gate-leave-review-btn {
        background: #2563eb;
        color: white;
        padding: 8px 16px;
        border: none;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        
        &:hover {
          background: #1d4ed8;
        }
      }
    }
  }
}

.gate-preview-white-content-negative {
  background: white;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  max-width: 672px;
  margin: 0 auto;
  
  .gate-negative-header {
    text-align: center;
    margin-bottom: 24px;
    
    .gate-negative-title {
      font-size: 20px;
      font-weight: 600;
      color: #111827;
      margin-bottom: 16px;
    }
  }
  
  .gate-negative-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
    
    .gate-form-field {
      display: flex;
      flex-direction: column;
      gap: 8px;
      
      .gate-form-label {
        display: block;
        font-size: 14px;
        font-weight: 500;
        color: #4b5563;
        margin-bottom: 8px;
        
        .gate-required {
          color: #ef4444;
        }
      }
      
      .gate-form-input,
      .gate-form-textarea {
        width: 100%;
        padding: 12px;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        font-size: 14px;
        transition: all 0.2s;
        outline: none;
        
        &:focus {
          box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
          border-color: #3b82f6;
        }
        
        &:disabled {
          background: #f9fafb;
          cursor: not-allowed;
        }
      }
      
      .gate-form-textarea {
        resize: none;
        min-height: 120px;
      }
    }
    
    .gate-submit-btn {
      width: 100%;
      background: #2563eb;
      color: white;
      padding: 12px 16px;
      border: none;
      border-radius: 8px;
      font-size: 18px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
      
      &:hover {
        background: #1d4ed8;
      }
    }
  }
  
  .gate-negative-footer {
    text-align: center;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e5e7eb;
    
    .gate-negative-footer-text {
      font-size: 14px;
      color: #6b7280;
      
      .gate-link-text {
        color: #2563eb;
        text-decoration: underline;
        font-weight: 500;
        cursor: pointer;
        
        &:hover {
          color: #1d4ed8;
        }
      }
    }
  }
}

.feedback-form {
  max-width: 500px;
  margin: 0 auto;

  .form-group {
    margin-bottom: 16px;

    label {
      display: block;
      margin-bottom: 6px;
      font-weight: 500;
      color: #374151;
    }
  }
}
</style>

